import React from 'react'
import OrderHeader from '../../shared/component/orderHeader/orderHeader'
import Card from '../../shared/assets/images/svg/assignment_blue_larg.svg'
import Invoice from '../../shared/assets/images/svg/invoice_large.svg'
import Trans from '../../shared/assets/images/svg/trans_large.svg'
import Stats from '../../shared/assets/images/svg/stats_large.svg'
import Coin from '../../shared/assets/images/svg/coin_Large.svg'
  


import ReportCard from './component/reportCard'
const Reports = () => {
  return (
    <div className='reports'>
      <div className='container'>
        <OrderHeader title="REPORTS" />
        <h1 className='page-title'>Hello,</h1>
        <div className='page-card'>
          <div className='customerName'>
            <img src={Card} alt="Card" />
            <h2>Customer Name</h2>
          </div>
          <div className='box-state'>
            <h2>Pending Invoices</h2>
            <span>550</span>
          </div>
          <div className='box-state'>
            <h2>Shipping Invoices</h2>
            <span>550</span>
          </div>
          <div className='box-state'>
            <h2>Opened Invoices</h2>
            <span>550</span>
          </div>
          <div className='box-state dark'>
            <h2>Current Ballance</h2>
            <span>550 SAR</span>
          </div>
        </div>

        <div className='row'>
          <div className='col-lg-3 col-md-6'>
            <ReportCard icon={Invoice} title="My Invoices" info="Services, Activities, And Billing Data" />
          </div>

          <div className='col-lg-3 col-md-6'>
            <ReportCard icon={Trans} title="Transactions" info="Username, Password, Support" />
          </div>

          <div className='col-lg-3 col-md-6'>
            <ReportCard icon={Stats} title="Statistics" info="Username, Password, Support" />
          </div>

          <div className='col-lg-3 col-md-6'>
            <ReportCard icon={Coin} title="Taxes" info="Username, Password, Support" />
          </div>


        </div>
      </div>
    </div>
  )
}

export default Reports